import React from 'react';
import { saveLibraryCreativeError, saveLibraryCreativeSuccess } from 'modules/creative-library/actions';
import { addIndication, INDICATION_TYPES } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { creativesLibraryApi } from 'services/api';
import { generateErrorIndication } from 'services/utils/errorMessagesUtils';

export const successIndication = {
    message: <FormattedMessage id="creative-library.save.success" defaultMessage="Creative successfully updated" />,
    type: INDICATION_TYPES.SUCCESS,
    highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
};

export const errorMessage = (
    <FormattedMessage
        id="creative-library.save.error"
        defaultMessage="We were not able to save changes to the creative"
    />
);

const updateCreative = async (creativeId, updateCreativeCall, accountId, creativeChanges) => {
    return await updateCreativeCall(accountId, creativeId, creativeChanges);
};

const updateLibraryCreativeBase = updateCreativeCall => (accountId, creativeId, creativeChanges) => async dispatch => {
    try {
        const result = await updateCreative(creativeId, updateCreativeCall, accountId, creativeChanges);
        dispatch(saveLibraryCreativeSuccess(result));
        dispatch(addIndication(successIndication));
        return { result };
    } catch (error) {
        dispatch(saveLibraryCreativeError(creativeId, error));
        dispatch(addIndication(generateErrorIndication(error, errorMessage)));
        throw error;
    }
};

export const updateLibraryCreative = updateLibraryCreativeBase(creativesLibraryApi.updateLibraryCreative);
